import cn from 'classnames';
import { Radio, RadioGroup } from 'ht-styleguide';
import { UPSELL_PLAN_BILLING_CYCLES } from 'src/constants/plan';
import styles from './selectplanradio.module.scss';

/*
  Annual Label Component

  Radio input label with the text gradient
*/
type LabelProps = {
  savings: string;
};
const AnnualLabel = ({ savings }: LabelProps) => (
  <>Pay Annually - {savings ? <span className={cn('text-weight-medium', styles.savingsLabel)}>Save {savings}</span> : null}</>
);
type SelectPlanRadioProps = {
  billingCycle: string;
  setBillingCycle: BaseAnyFunction;
  annualSavings: string;
  stacked?: boolean;
};
const SelectPlanRadio = ({ billingCycle, setBillingCycle, annualSavings, stacked = true }: SelectPlanRadioProps) => {
  const { ANNUAL, MONTHLY } = UPSELL_PLAN_BILLING_CYCLES;
  const containerClass = cn(styles.container, { [styles.inline]: !stacked });

  return (
    <RadioGroup
      value={billingCycle}
      onChange={setBillingCycle}
      containerClassName={containerClass}
      rowClassName={styles.rowClass}
      columnClassName={styles.columnClass}
    >
      <Radio value={ANNUAL} label={<AnnualLabel savings={annualSavings} />} wrapperClass={styles.radioLabel} labelClass={styles.labelClass} />
      <Radio value={MONTHLY} label="Pay Monthly" wrapperClass={styles.radioLabel} labelClass={styles.labelClass} />
    </RadioGroup>
  );
};

export default SelectPlanRadio;
